export enum Roles {
  ROLE_SUPER_ADMIN = 'Super Admin',
  ROLE_ADMIN = 'Admin',
  ROLE_TEACHER = 'Teacher',
  ROLE_USER = 'User'
}
